import {
    ContextualMenu, DefaultButton, getId, Icon, IDragOptions, IDropdownOption,
    Link, List, Modal, Panel, PanelType, SearchBox
} from "@fluentui/react";
import React, { useState } from "react";
import { DataUtils } from "../../../common/views/DataUtils";
import ModalHeaderView from "../../../common/views/ModalHeaderView";
import { StyleUtils } from "../../../common/views/StyleUtils";
import { Utils } from "../../../common/views/Utils";
import { PopUpType } from "../../../home/models/OtherTypes";

export type SelectBrandProps = {
    value: number;
    onChange: (value: number) => void;
    options: IDropdownOption[];
    type: PopUpType;
}

export default function SelectBrandView({ value, onChange, options, type }: SelectBrandProps) {
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');
    const dragOptions: IDragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };

    const getOption = (value: number) => {
        return options.find((opt: IDropdownOption) => opt.key === value);
    }

    const [showMenu, setShowMenu] = useState(false);
    const [selectedOption, setSelectedOption] = useState<IDropdownOption | undefined>(getOption(value));
    const [filteredOptions, setFilteredOptions] = useState<IDropdownOption[]>(options);
    const [listHash, setListHash] = useState(Utils.getRandomKey());
    const [recentItems, setRecentItems] = useState<any[]>([]);

    const searchInput = () => {
        return <SearchBox
            autoFocus={false}
            placeholder="Search"
            onSearch={newValue => onTextChange(newValue)}
            onClear={() => onTextChange("")}
            styles={{ root: { width: "100%", maxWidth: 500 } }}
            className="pb-10"
            underlined={true}
        />
    }

    const modalView = () => {
        return <>
            <Modal
                titleAriaId={titleId}
                subtitleAriaId={subtitleId}
                isOpen={showMenu}
                onDismiss={hideMenu}
                isBlocking={true}
                dragOptions={dragOptions}
                styles={StyleUtils.getModalWidthStyles(500)}
            >
                <ModalHeaderView title="Brands" onClose={hideMenu} />

                <div id={subtitleId} className="popup-body" style={{ height: "90vh", overflowY: "auto" }}>
                    {bodyView()}
                </div>
            </Modal>
        </>;
    }

    const panelView = () => {
        return <>
            <Panel
                isOpen={showMenu}
                isBlocking={false}
                isLightDismiss={true}
                type={PanelType.custom}
                customWidth={DataUtils.PANEL_WIDTH}
                onDismiss={hideMenu}
                closeButtonAriaLabel="Close"
                styles={{ content: { paddingLeft: "20px !important", paddingRight: "20px !important" } }}
            >
                {bodyView()}
            </Panel>
        </>;
    }

    const bodyView = () => {
        return <>
            <div>
                <div className="pb-10"><b>Recent Selections: </b></div>
                {recentItems.map((item: any) => {
                    return <>
                        <DefaultButton
                            text={item.text}
                            className="filter-text"
                            style={{ height: 25 }}
                            onClick={() => onRecentClick(item)}
                        />
                    </>;
                })}
            </div>

            {searchInput()}

            <div className="pv-10">
                {alphabetElement()}
            </div>

            <div style={{ height: "75vh", overflowY: "auto" }}>
                <List items={filteredOptions} key={listHash} onRenderCell={onRenderRow} />
            </div>
        </>;
    }

    const onRenderRow = (item?: IDropdownOption, index?: number) => {
        if (!item) return <></>;

        index = index ?? 0;

        const background = index % 2 === 0 ? "alt-color" : "";

        return <>
            <div
                className={"brand-item-row " + background}
                onClick={() => onSelectedChange(item)}
            >{item.text}</div>
        </>;
    }

    const alphabetElement = () => {
        const obj: any = {};

        for (let i = 0; i < options.length; i++) {
            const letter = options[i].text ? options[i].text.substr(0, 1).toUpperCase() : "";
            obj[letter] = letter;
        }

        const list = [];

        for (let key in obj) list.push(key);

        return <div>
            {list.map((value: string) => <div className="brand-letter">
                <Link onClick={() => filterByLetter(value)}>{value}</Link>
            </div>)}

            <div className="brand-letter">
                <Link onClick={() => onTextChange("")}>ALL</Link>
            </div>
        </div>
    }

    const onTextChange = (newValue: string) => {
        const req = new RegExp(newValue, 'i');

        const filteredOptions = options.filter((value: IDropdownOption) => req.test(value.text));

        setFilteredOptions(filteredOptions);
        setListHash(Utils.getRandomKey());
    }

    const filterByLetter = (letter: string) => {
        const filteredOptions = options.filter(
            (value: IDropdownOption) => value.text.substr(0, 1).toUpperCase() === letter
        );

        setFilteredOptions(filteredOptions);
        setListHash(Utils.getRandomKey());
    }

    const onSelectedChange = (option: IDropdownOption) => {
        const value = option.key as number;

        setSelectedOption(option);
        setShowMenu(type === PopUpType.panel);

        if (!recentItems.find((item: any) => item.value === value)) {
            recentItems.unshift({ value: value, text: option.text });
            setRecentItems(recentItems);
        }

        onChange(value);
    }

    const onClear = () => {
        setSelectedOption(undefined);
        onChange(0);
    }

    const onRecentClick = (item: any) => {
        setSelectedOption(item);
        setShowMenu(type === PopUpType.panel);

        onChange(item.value);
    }

    const hideMenu = () => {
        setShowMenu(false);
    }

    return <>
        <div className="pb-5" style={{ paddingTop: 5 }}>
            <span className="pr-5 font-bolder">Brand</span>
            <Icon className="pointer" iconName="cancel" onClick={onClear} />
        </div>
        <div className="brand-dropdown" onClick={() => setShowMenu(true)}>
            <div className="brand-dropdown-text">{selectedOption?.text}</div>
            <div className="brand-dropdown-icon"><Icon iconName="ChevronDown" /></div>
        </div>

        {type === PopUpType.modal && modalView()}
        {type === PopUpType.panel && panelView()}
    </>;
}